import { AlertDialog, AlertDialogOverlay,AlertDialogHeader, AlertDialogContent, AlertDialogBody, AlertDialogFooter ,Button} from "@chakra-ui/react";

function ConfirmDialog(props) {
  const onDelete =()=>{
    props.onClose()
    props.onDelete()
  }
    return (
      <>
        <AlertDialog
          isOpen={props.isOpen}
          leastDestructiveRef={props.onClose}
          onClose={props.onClose}
        >
          <AlertDialogOverlay>
            <AlertDialogContent>
              <AlertDialogHeader fontSize="lg" fontWeight="bold">
                {props.header}
              </AlertDialogHeader>
  
              <AlertDialogBody>
                {props.body}
              </AlertDialogBody>
              <AlertDialogFooter>
                <Button onClick={props.onClose}>
                  Cancel
                </Button>
                <Button colorScheme="red" onClick={onDelete} ml={3}>
                  Delete
                </Button>
              </AlertDialogFooter>
            </AlertDialogContent>
          </AlertDialogOverlay>
        </AlertDialog>
      </>
    )
  }

  export default ConfirmDialog;
